import { ViewModeConstants } from "../../constants/ViewModeConstants";

export const VIEW_MODES = [ViewModeConstants.DATA_CARDS, ViewModeConstants.TABLE] as const;
export type ViewMode = typeof VIEW_MODES[number];
export const isViewMode = (v: unknown): v is ViewMode =>
    typeof v === 'string' && (VIEW_MODES as readonly string[]).includes(v);
